import { useEffect, useRef } from 'react';

import { STEPS } from './constants';

export const useResetOnOpen = ({ isOpen, nextCrumb, formikRef, setSelectedRows }) => {
  const wasOpenRef = useRef(false);

  useEffect(() => {
    if (isOpen && !wasOpenRef.current) {
      nextCrumb(STEPS[0]);
      formikRef.current?.resetForm();
      setSelectedRows([]);
    }
    wasOpenRef.current = !!isOpen;
  }, [isOpen, nextCrumb, formikRef, setSelectedRows]);
};
